import { Portfolio } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { Group } from 'types/groupService';
import { EnrollmentPeriod } from 'types/enrollmentService';
import { Cart } from './cartServiceV2';

interface RateResponse {
  portfolioId: string;
  productId: string;
  rates: Record<string, string>;
}

type EstimatedCostData = { [key: string]: Record<string, string> };

export interface EstimatedCostObject {
  rateResponse: RateResponse;
  estimatedCost: EstimatedCostData;
  employeeCount: EstimatedCostData;
}

export interface ProposalGenerationState {
  cartId: string;
  lastUpdateTime: string;
  generateProposalAnswers: Record<string, string>;
  estimatedCost: EstimatedCostObject[];
}

export enum ProposalGenerationStatus {
  NOT_EXIST = 'NOT_EXIST',
  OUTDATED = 'OUTDATED',
  IDENTICAL = 'IDENTICAL',
}

export interface ProposalRequest {
  domainId: string;
  catalogId: string;
  cart: Cart;
  group: Group;
  portfolios: Portfolio[];
  period: EnrollmentPeriod;
}

export enum ProposalFileType {
  PDF = 'PDF',
  SHEET = 'SHEET',
}

export type ProposalValidationError =
  | { type: 'DEPENDENT_PRODUCT_LINES'; productLineIds: ProductLineId[] }
  | { type: 'DOVETAILING' }
  | { type: 'REQUIRED_CROSS_SELL'; addedPortfolioName: string; requiredPortfolioName: string };
